import { CUSTOMER_NEEDS } from '@ahmdigital/constants';

import getTitleFromType from '../../../../utils/get-title-from-type';
import Head from '../../../../../utils/head';

type ProductListingHeadProps = {
  needsProductType: string | undefined;
  needsType: string;
  productType: string;
};

export const metadata: Record<string, Record<string, { description?: string; title: string }>> = {
  [CUSTOMER_NEEDS.EXTRAS_COVER]: {
    [CUSTOMER_NEEDS.ALL]: {
      description:
        'Compare extras insurance cover options for services like dental, physio, optical & ambulance, plus more! View the full range here. Buy online today.',
      title: 'Health insurance extras cover plans',
    },
  },
  [CUSTOMER_NEEDS.HOSPITAL_COVER]: {
    [CUSTOMER_NEEDS.ALL]: {
      description:
        'Compare hospital cover options, find the best hospital cover for you. Options and control in case of in-hospital treatments, including elective surgeries and medical surgeries.',
      title: 'Compare hospital cover plans',
    },
  },
};

export const DEFAULT_DESCRIPTION = `Compare ahm’s hospital and extras packages. We’ve got your back with a range of private health insurance options and plans to suit your needs.`;

const ProductListingHead = ({ needsProductType, needsType, productType }: ProductListingHeadProps) => {
  const pageMetadata = needsProductType ? metadata[needsType]?.[needsProductType] : undefined;

  const title =
    pageMetadata?.title ?? `Health insurance ${getTitleFromType({ needsProductType, needsType, productType })}`;
  const description = pageMetadata?.description ?? DEFAULT_DESCRIPTION;

  return (
    <Head>
      <title>{title}</title>
      <meta name="description" content={description} />
    </Head>
  );
};

export default ProductListingHead;
